module.exports = __webpack_public_path__ + "static/media/border-left.cdb0fd9c.svg";